import React from 'react';
import classNames from 'classnames';
import CtaCardMap from './CtaCardMap/CtaCardMap';
import CtaCardSimple from './CtaCardSimple/CtaCardSimple';
import CtaCardSubscribe from './CtaCardSubscribe/CtaCardSubscribe';
import CtaForm from './CtaForm/CtaForm';
import Cutaway from './Cutaway/Cutaway';
import CtaContactForm from './CtaContactForm/CtaContactForm';
import { defaultData } from './CtaForm/defaultCrossmodFormData';

interface Props {
  section: {
    ctaStyle: {
      type: string;
    };
  };
}

const getCtaComponent = ({ section }) => {
  switch (section.ctaStyle?.type) {
    case 'cutaway':
      return <Cutaway />;

    case 'form-contact':
      return (
        <CtaContactForm
          title={section.title}
          description={section.description}
          includeSegment={section.includeSegment}
        />
      );

    case 'form-cta':
      return (
        <CtaForm
          image={section?.image || defaultData.image}
          imageHeading={section?.imageHeading || defaultData.imageHeading}
          heading={section?.heading || defaultData.heading}
          description={defaultData.description}
          formSections={section?.formSections || defaultData.formSections}
          disclaimer={section?.disclaimer || defaultData.disclaimer}
          includeSegment={section?.includeSegment}
        />
      );

    case 'form-subscribe':
      return (
        <div
          className={classNames(
            'mx-auto mb-0 mt-[50px] px-0',
            section?.padding?.top && section.padding.top !== 'default'
              ? `pt-[${section.padding.top}px]`
              : 'pt-2.5',
            section?.padding?.bottom && section.padding.bottom !== 'default'
              ? `pb-[${section.padding.bottom}px]`
              : 'pb-2.5'
          )}
        >
          <CtaCardSubscribe
            title={section.title}
            description={section.description}
            includeSegment={section?.includeSegment}
          />
        </div>
      );

    case 'map':
      return (
        <CtaCardMap
          paragraphStyle={section.paragraphStyle}
          officeLocations={section.officeLocations}
          mapStyle={section.ctaStyle.officeLocationTypeFilter}
        />
      );

    default:
      return (
        <div
          className={classNames(
            'mx-auto mb-0 mt-[50px] w-mobile max-w-standard px-0',
            section?.padding?.top && section.padding.top !== 'default'
              ? `pt-[${section.padding.top}px]`
              : 'pt-2.5',
            section?.padding?.bottom && section.padding.bottom !== 'default'
              ? `pb-[${section.padding.bottom}px]`
              : 'pb-2.5'
          )}
        >
          <CtaCardSimple
            title={section.title}
            description={section.description}
            paragraphStyle={section.paragraphStyle}
            buttonLabel={section.button?.label}
            buttonUrl={section.button?.url}
            buttonOpenNewWindow={section.button?.isOpenNewWindow}
            includeSegment={section?.includeSegment}
          />
        </div>
      );
  }
};

const CtaCard = ({ section }: Props) => {
  if (!section) {
    return;
  }

  return (
    <div>
      <div
        className={classNames({
          ['mx-auto w-mobile max-w-standard pb-[30px]']:
            section?.ctaStyle?.type !== 'cutaway' &&
            section?.ctaStyle?.type !== 'map' &&
            !section?.ctaStyle?.type.startsWith('form'),
        })}
      >
        {getCtaComponent({ section })}
      </div>
    </div>
  );
};

export default CtaCard;
